import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { ArrowLeft, Check, X, Image } from 'lucide-react';
interface PODReviewProps {
  onBack: () => void;
}
export function PODReview({
  onBack
}: PODReviewProps) {
  return <div className="space-y-6" data-id="element-444">
      <div className="flex items-center gap-4" data-id="element-445">
        <Button variant="ghost" onClick={onBack} icon={<ArrowLeft size={20} data-id="element-447" />} data-id="element-446">
          Kembali
        </Button>
        <div data-id="element-448">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-449">
            Review Proof of Delivery (POD)
          </h1>
          <p className="text-gray-500" data-id="element-450">
            DO #DO-2025-002 • Kelurahan Kebon Jeruk
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-451">
        <Card title="Bukti Foto" data-id="element-452">
          <div className="grid grid-cols-2 gap-4" data-id="element-453">
            <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center relative group cursor-pointer" data-id="element-454">
              <Image className="text-gray-400" size={32} data-id="element-455" />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all flex items-center justify-center" data-id="element-456">
                <span className="text-white opacity-0 group-hover:opacity-100 font-medium" data-id="element-457">
                  Lihat Full
                </span>
              </div>
            </div>
            <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-458">
              <Image className="text-gray-400" size={32} data-id="element-459" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-500" data-id="element-460">
            <p data-id="element-461">Lokasi GPS: -6.1923, 106.8231 (Sesuai)</p>
            <p data-id="element-462">Waktu: 20 Mei 2025, 14:30 WIB</p>
          </div>
        </Card>

        <Card title="Konfirmasi Penerimaan" data-id="element-463">
          <div className="space-y-4" data-id="element-464">
            <div className="p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-465">
              <p className="text-sm text-gray-500 mb-1" data-id="element-466">Penerima</p>
              <p className="font-bold text-lg" data-id="element-467">Bpk. Ketua RW 05</p>
              <div className="h-20 bg-white mt-2 border border-gray-300 rounded flex items-center justify-center text-gray-400 italic" data-id="element-468">
                Tanda Tangan Digital
              </div>
            </div>

            <Input label="Jumlah Diterima (Karung)" defaultValue="500" data-id="element-469" />
            <Input label="Catatan / Keterangan" placeholder="Diterima dengan baik..." data-id="element-470" />

            <div className="flex gap-3 pt-4" data-id="element-471">
              <Button className="flex-1" icon={<Check size={18} data-id="element-473" />} data-id="element-472">
                Approve POD
              </Button>
              <Button variant="danger" className="flex-1" icon={<X size={18} data-id="element-475" />} data-id="element-474">
                Reject / Masalah
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}